import React from 'react';

export const IsLoading:any = React.createContext({loading: false, setLoading: ()=>{}});
